import CourseListCoursesByJobTitle from './Request/Course_listCoursesByJobTitle';
import graphql from './graphql';
import minutesToHour from '../Utils/MinutesToHours';
import arrayToString from '../Utils/ArrayToString';
import courseSetJobTitleType from './Request/Course_SetJobTitleType';

const mapCourseList = courses =>
  courses.map(course => [
    course.name || '',
    arrayToString(course?.Enterprise?.Terminals, 'name'),
    minutesToHour(course.duration),
    course?.CourseCategory.name || 'sin categoría',
    course?.Enterprise?.Terminals,
    course.id,
    !!course.CourseType?.type,
    course.isChecked,
  ]);

const mapCategories = coursesEnterprise => coursesEnterprise.map(category => category.name || '');

const mapTerminal = data => data.map(terminal => terminal.name);

const fetch = async (departmentId, jobTitleId) => {
  const promises = [];
  promises.push(CourseListCoursesByJobTitle(departmentId, jobTitleId));
  promises.push(graphql('CourseCategory_list', 'name', 'query'));
  promises.push(graphql('Terminal_list', 'name', 'query'));

  const response = await Promise.all(promises);
  const courseByEnterprise = mapCourseList(response[0].EnterpriseCourses);
  const courseByDepartment = mapCourseList(response[0].DepartmentCourses);
  const courseByJobTitle = mapCourseList(response[0].JobTitleCourses);
  const categories = mapCategories(response[1].CourseCategory_list);
  const terminals = mapTerminal(response[2].Terminal_list);
  return {
    courseByEnterprise,
    courseByDepartment,
    courseByJobTitle,
    categories,
    terminals,
  };
};

export default fetch;

export const update = async (coursesData, jobTitleId) => courseSetJobTitleType(coursesData, jobTitleId);
